import * as types from '../../../../lib/actionTypes.es6'

const initialState = {
  sessions_loader: false,
  ussd_sessions: null,
  get_sessions_error: null,

  messages_loader: false,
  ussd_messages: null,
  get_messages_error: null,

  flows_loader: false,
  ussd_flows: null,
  get_flows_error: null,

  simulate_loader: false,
  simulate_run_context: null,
  simulate_error: null
}

export default function ussdSessionsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_USSD_SESSIONS_REQUEST:
      return { ...state, sessions_loader: true, get_sessions_error: null }
    case types.GET_USSD_SESSIONS_SUCCESS:
      return {
        ...state,
        sessions_loader: false,
        ussd_sessions: action.payload,
        get_sessions_error: null
      }
    case types.GET_USSD_SESSIONS_FAIL:
      return {
        ...state,
        sessions_loader: false,
        get_sessions_error: action.payload
      }

    case types.GET_USSD_MESSAGES_REQUEST:
      return { ...state, messages_loader: true, get_messages_error: null }
    case types.GET_USSD_MESSAGES_SUCCESS:
      return {
        ...state,
        messages_loader: false,
        ussd_messages: action.payload,
        get_messages_error: null
      }
    case types.GET_USSD_MESSAGES_FAIL:
      return {
        ...state,
        messages_loader: false,
        get_messages_error: action.payload
      }

    case types.GET_USSD_FLOWS_REQUEST:
      return { ...state, flows_loader: true, get_flows_error: null }
    case types.GET_USSD_FLOWS_SUCCESS:
      return {
        ...state,
        flows_loader: false,
        ussd_flows: action.payload,
        get_flows_error: null
      }
    case types.GET_USSD_FLOWS_FAIL:
      return { ...state, flows_loader: false, get_flows_error: action.payload }

    case types.SIMULATE_START_REQUEST:
    case types.SIMULATE_RESUME_REQUEST:
      return { ...state, simulate_loader: true, simulate_error: null }
    case types.SIMULATE_START_SUCCESS:
    case types.SIMULATE_RESUME_SUCCESS:
      return {
        ...state,
        simulate_loader: false,
        simulate_run_context: action.payload,
        simulate_error: null
      }
    case types.SIMULATE_START_FAIL:
    case types.SIMULATE_RESUME_FAIL:
      return {
        ...state,
        simulate_loader: false,
        simulate_error: action.payload
      }
    case types.SIMULATE_RESET:
      return { ...state, simulate_run_context: null, simulate_error: null }

    default:
      return state
  }
}
